module.exports = __webpack_public_path__ + "img/search.41380278.svg";